<div
  fxLayout="column"
  fxLayoutAlign="center center"
  class="shopping-cart__emptyCart"
  test-target="mini-shopping-cart-empty"
  [ngClass]="{'shopping-cart__emptyCart__expanded': expanded}"
>
  <div class="shopping-cart__emptyCart__icon"></div>
  <span class="shopping-cart__emptyCart__message">{{'CART.EMPTY_CART.TITLE' | translate}}</span>
  <ng-container *ngIf="!deleteFlag && !undoCart">
    <div class="shopping-cart__emptyCart__line"></div>
    <p>{{ 'CART.EMPTY_CART.MESSAGE' | translate }}</p>
    <a
      fxLayoutAlign="center center"
      class="shopping-cart__emptyCart__button"
      [routerLink]="catalogRoute"
      [queryParams]="queryParams"
      (click)="trackGoToPromotionsClick()">
      {{ 'CART.EMPTY_CART.BUTTON.TITLE' | translate }}
    </a>
  </ng-container>
</div>
